import { inject, PLATFORM_ID, DOCUMENT } from '@angular/core';
import { HttpRequest, HttpHandlerFn } from '@angular/common/http';
import { isPlatformBrowser } from '@angular/common';
import { ClusterService } from '@mogenius/cluster/services/cluster-service/cluster.service';
import { OrganizationService } from '@mogenius/organization/services/organization-service/organization.service';
import { WorkspaceService } from '@mogenius/workspace/services/workspace.service';
import { generateCorrelationId } from '@mogenius/client-sdk/core';

export function requestHeaderInterceptor(req: HttpRequest<unknown>, next: HttpHandlerFn): any {
  const platform = inject(PLATFORM_ID);
  const document = inject(DOCUMENT);
  const clusterId = inject(ClusterService).selectedCluster$.value?.id;
  const organizationId = inject(OrganizationService).selectedOrganization$.value?.id;
  const workspaceName = inject(WorkspaceService).selectedWorkspace$.value?.name;

  if (isPlatformBrowser(platform)) {
    const domain = `${document.location.protocol}//${document.location.host}`;
    const headers: Record<string, string> = {
      'request-domain': domain,
      'cluster-id': req.headers.get('cluster-id') ?? clusterId ?? '',
      'organization-id': req.headers.get('organization-id') ?? organizationId ?? '',
      'workspace-name': req.headers.get('workspace-name') ?? workspaceName ?? '',
      'x-correlation-id': generateCorrelationId(),
      'x-frontend-request': `${window?.location}`
    };
    req = req.clone({ setHeaders: headers });
  }
  return next(req);
}
